import { render } from "./AlertDialog.vue?vue&type=template&id=ffd5ae6c"
import script from "./AlertDialog.vue?vue&type=script&lang=js"
export * from "./AlertDialog.vue?vue&type=script&lang=js"

import "./AlertDialog.vue?vue&type=style&index=0&id=ffd5ae6c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__